import { Alert, Box } from '@cloudscape-design/components';
import type { ReactNode } from 'react';

import { useAuth } from './useAuth';

const SCORECARD_ADMIN_EMAILS = new Set(['adam@maestros.com', 'max@aiescape.io']);
const LOCAL_SCORECARD_ADMIN_EMAIL = 'dev@aiescape.io';

export function canAccessScorecardAdmin(
  email: string | null | undefined,
  isDevelopment = import.meta.env.DEV,
): boolean {
  const normalizedEmail = email?.trim().toLowerCase();
  return (
    normalizedEmail !== undefined &&
    (SCORECARD_ADMIN_EMAILS.has(normalizedEmail) ||
      (isDevelopment && normalizedEmail === LOCAL_SCORECARD_ADMIN_EMAIL))
  );
}

export function ScorecardAdminAccessRequired({ children }: { children: ReactNode }) {
  const { user } = useAuth();

  if (!canAccessScorecardAdmin(user?.email)) {
    return (
      <Box padding="xxl" textAlign="center">
        <Alert type="error" header="Page access denied">
          You do not have access to this page.
        </Alert>
      </Box>
    );
  }

  return <>{children}</>;
}
